import React, { memo } from 'react';
import PropTypes from 'prop-types';

const Disclaimer = ({ title, body }) => (
  <>
    <div className="learn-more-accordion" id="learnMore">
      <div className="accordion-item">
        <div className="accordion-header" id="learnMoreTitle">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#learnMoreBody"
            aria-expanded="false"
            aria-controls="learnMoreBody"
          >
            {title}
          </button>
        </div>
        <div
          id="learnMoreBody"
          className="accordion-collapse collapse"
          aria-labelledby="learnMoreTitle"
          data-bs-parent="#learnMore"
        >
          <div className="accordion-body">{body}</div>
        </div>
      </div>
    </div>
    <div className="learn-more-spacer" />
  </>
);

Disclaimer.propTypes = {
  title: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.elementType, PropTypes.shape()]),
};

Disclaimer.defaultProps = {
  title: null,
  body: null,
};

export default memo(Disclaimer);
